const ScheduledAssessment = () => {
  return <div>ScheduledAssessment</div>;
};

export default ScheduledAssessment;
